/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProcessState } from "./ProcessState";
import {
  ProcessStateFromJSON,
  ProcessStateFromJSONTyped,
  ProcessStateToJSON,
} from "./ProcessState";

export interface DigestionUpdateRequest {
  locked?: boolean;
  workflowId?: string | null;
  workflowContext?: object | null;
  state?: ProcessState;
  progress?: number | null;
  error?: object | null;
  name?: string | null;
  note?: string | null;
  context?: object | null;
}

export function DigestionUpdateRequestFromJSON(
  json: any,
): DigestionUpdateRequest {
  return DigestionUpdateRequestFromJSONTyped(json);
}

export function DigestionUpdateRequestFromJSONTyped(
  json: any,
): DigestionUpdateRequest {
  if (json == null) {
    return json;
  }

  return {
    locked: json["locked"],
    workflowId: json["workflow_id"],
    workflowContext: json["workflow_context"],
    state:
      json["state"] === undefined
        ? undefined
        : ProcessStateFromJSON(json["state"]),
    progress: json["progress"],
    error: json["error"],
    name: json["name"],
    note: json["note"],
    context: json["context"],
  };
}

export function DigestionUpdateRequestToJSON(
  value: DigestionUpdateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    locked: value.locked,
    workflow_id: value.workflowId,
    workflow_context: value.workflowContext,
    state: ProcessStateToJSON(value.state),
    progress: value.progress,
    error: value.error,
    name: value.name,
    note: value.note,
    context: value.context,
  };
}
